import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../components/EmptyState';
import { TableSkeleton } from '../../components/TableSkeleton';
import { buildOwnerColumns } from './build-owner-columns';
import { CreateOwnerDrawer } from './CreateOwnerDrawer';
import { OwnersTable } from './OwnersTable';
import { useOwners } from './use-owners';

/** One of `FleetPage`'s tabs, alongside Trucks and Trailers — no `PageHeader` of its own, that tab shell already has one. */
export function OwnersPage() {
  const { state, list, isRefreshing, createError, creating, create, resetCreateError } = useOwners();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildOwnerColumns({ list });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button
          type="primary"
          icon={<Plus className="size-4" />}
          onClick={() => {
            resetCreateError();
            setDrawerOpen(true);
          }}
        >
          Create owner
        </Button>
      </div>
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load owners" description="Something went wrong loading the owners list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading owners" withSearch />}
      {state.status === 'loaded' && <OwnersTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateOwnerDrawer open={drawerOpen} error={createError} submitting={creating} onCreate={create} onClose={() => setDrawerOpen(false)} />
    </div>
  );
}
